import { connect } from 'react-redux'

import { IState } from '../../redux/state'
import { Header as HeaderComponent } from './Header'
import { PropsFromState } from './props'

const mapStateToProps = (state: IState): PropsFromState => {
  const { isDetailViewVisible, isSmallScreen } = state.ui.detailView

  return {
    inMobileDetailView: isDetailViewVisible && isSmallScreen,
  }
}

// tslint:disable-next-line:variable-name
export const Header = connect(mapStateToProps)(HeaderComponent)
